import { toast } from 'sonner'
import _ from 'lodash'

export const handleFormError = ({
  error,
  variables,
  setError,
  showToast = false,
  clientServerFieldMapping: _clientServerFieldMapping = null,
}) => {
  if (!error?.hasFieldError) return
  const serverFieldErrors = error?.response?.data?.errors ?? []

  let fieldFound = false
  const clientServerFieldMapping =
    variables?.clientServerFieldMapping ?? _clientServerFieldMapping ?? {}

  //Swap key values so we can easily look for server fieldName
  const serverClientFieldMapping = Object.fromEntries(
    Object.entries(clientServerFieldMapping).map(([key, value]) => [
      value,
      key,
    ]),
  )

  Object.entries(serverFieldErrors).map(([serverFieldName, value]) => {
    const serverFieldNameCamelCase = _.camelCase(serverFieldName)

    const availableClientFieldNameFromTheRequest =
      serverFieldName in serverClientFieldMapping
        ? serverClientFieldMapping[serverFieldName]
        : serverFieldNameCamelCase in variables
          ? serverFieldNameCamelCase
          : null

    if (availableClientFieldNameFromTheRequest) {
      const error = (value ?? [])[0]
      if (error) {
        if (setError)
          setError(availableClientFieldNameFromTheRequest, { message: error })
        fieldFound = true
        if (showToast || !setError) {
          toast.error(error)
        }
      }
    }
  })

  if (!fieldFound) {
    toast.error(error?.response?.data?.message ?? 'An error occurred.')
  }
}

export const addOrdinalSuffix = (i) => {
  let j = i % 10,
    k = i % 100
  if (j === 1 && k !== 11) {
    return i + 'st'
  }
  if (j === 2 && k !== 12) {
    return i + 'nd'
  }
  if (j === 3 && k !== 13) {
    return i + 'rd'
  }
  return i + 'th'
}

export const isNumeric = (str) => {
  if (typeof str != 'string') return false // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ) // ...and ensure strings of whitespace fail
}

export const capitalizeFirstLetter = (val) => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1)
}
